import * as DTOS from "../FeralScan.dtos";

export interface IAdminActions {
    type: string;
}

export interface ISearchTemplatesRequest extends IAdminActions {
    searchText?: string;
    templateId?: number;
}

export interface ISearchTemplatesSuccess extends IAdminActions {
    templates: DTOS.Template[];
}

export const
    SEARCH_TEMPLATES_REQUEST = "SEARCH_TEMPLATES_REQUEST",
    SEARCH_TEMPLATES_SUCCESS = "SEARCH_TEMPLATES_SUCCESS",
    SEARCH_TEMPLATES_FAILURE = "SEARCH_TEMPLATES_FAILURE";

export function searchTemplatesRequest(searchText?: string, templateId?: number): ISearchTemplatesRequest {
    return {
        type: SEARCH_TEMPLATES_REQUEST,
        searchText,
        templateId
    };
}

export function searchTemplatesSuccess(response: DTOS.GetTemplateResponse): ISearchTemplatesSuccess {
    return {
        type: SEARCH_TEMPLATES_SUCCESS,
        templates: response.templates
    };
}
